import { useState, useEffect, useLayoutEffect } from "react";
import useFetch from "../../../utils/useFetch";
import TickRoundIcon from "../../../icons/TickRoundIcon";
import HourglassIcon from "../../../icons/HourglassIcon";
import TriangleExclamationIcon from "../../../icons/TriangleExclamationIcon";
import CollectionsTemplate from "../../../components/CollectionsTemplate/index";

import DashboardGriditem from "./DashboardGriditem";
import DashboardListitem from "./DashboardListitem";
import DashboardCollectionControl from "./DashboardCollectionControls";
import EmptyComponent from "../../../utils/EmptyComponent";
import apiinfo from "../../../utils/base-uri.json";
import axios from "../../../utils/fvAxios";
import GetfVDateFormate from "../../../utils/Genaricfunctions";
import { useTranslation } from "react-i18next";
import "../../../Localization/i18n";
import VendorDashboard from "./VendorDashboard";
import ClientDashboard from "./ClientDashboard";

const pageSize = 12;
const queryUrl = apiinfo.dashboard.GetPrequalificationsforAdminDashboard;

function vendorDataAdaptor(data, t) {
  return {
    headers: [
      { id: "vendorName", text: t("Dashboard.vendorName"), width: "25%" },
      { id: "indicationTextClient", text: t("Dashboard.Status"), width: "27%" },
      {
        id: "prequalificationSubmit",
        text: t("Dashboard.Submitted"),
        width: "30%",
      },
      {
        id: "prequalificationCreate",
        text: t("Dashboard.statusPeriod"),
        width: "30%",
      },
      { id: "clientName", text: t("Dashboard.client"), width: "20%" },
      { id: "logo", width: "5%" },
    ],
    isEditable: {
      callback: (item) => {
        console.log(item);
      },
      isVisible: true,
    },
    isDeletable: {
      callback: (item) => {
        console.log(item);
      },
      isVisible: true,
    },
    rows: data?.data?.map((d) =>
      Object.assign({}, d, {
        key: d.prequalificationId,
      })
    ),
    statusRoleMap: {
      prequalified: {
        text: "Prequalified",
        role: "success",
        icon: TickRoundIcon,
      },
      pending: { text: "Pending", role: "warning", icon: HourglassIcon },
      clientReview: {
        text: "Client Review",
        role: "warningLight",
        icon: HourglassIcon,
      },
      Expired: {
        text: "Expired",
        role: "warningLight",
        icon: TriangleExclamationIcon,
      },
      Probation: {
        text: "Probation",
        role: "error",
        icon: TriangleExclamationIcon,
      },
    },
  };
}

//From https://stackoverflow.com/a/71061690/751002

export default function () {
  function toQueryString(obj) {
    return "?".concat(
      Object.keys(obj)
        .map((e) =>
          obj[e]
            ? `${encodeURIComponent(e)}=${encodeURIComponent(obj[e])}`
            : null
        )
        .filter((e) => !!e)
        .join("&")
    );
  }

  function getUrl(url, data) {
    return `${url}${toQueryString(data)}`;
  }
  var d = new Date();
  var year = d.getFullYear();
  var month = d.getMonth();
  var day = d.getDate();
  var cf = GetfVDateFormate("", "", new Date(year - 20, month, day));
  var c1t = GetfVDateFormate("", "", new Date(year, month - 1, day));
  var c2t = GetfVDateFormate("", "", new Date(year, month, day));
  var c3f = GetfVDateFormate("", "", new Date(year, month - 1, day));
  var c4t = GetfVDateFormate("", "", new Date(year, month, day));
  var c5f = GetfVDateFormate("", "", new Date(year, month, day - 1));

  const [viewType, setViewType] = useState("grid");
  const [pageCount, setPageCount] = useState(1);
  const [countInfo, setCountInfo] = useState();
  const [collection, setCollection] = useState({});
  const [paramsState, setParamsState] = useState({
    pageNumber: 1,
    pageSize: 12,
    freeText: "",
    type: 5,
    fromDate: cf,
    toDate: c1t,
  });
  const [url, setUrl] = useState(
    getUrl(queryUrl, { ...paramsState, pageSize })
  );
  const { data: collectionData, loading, error } = useFetch(url);

  useLayoutEffect(() => {
    setUrl(getUrl(queryUrl, { ...paramsState, pageSize }));
  }, [paramsState]);

  useLayoutEffect(() => {
    componentDidMount();
  }, [paramsState.freeText]);

  function componentDidMount() {
    axios
      .get(
        apiinfo?.dashboard?.GetPrequalificationsDashboardCount +
        "?freeText=" +
        paramsState.freeText
      )
      .then((res) => {
        setCountInfo(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const { t } = useTranslation();
  useLayoutEffect(() => {
    if (collectionData) {
      //setPageCount(Math.ceil((collectionData.count || pageSize) / pageSize));
      setPageCount(Math.ceil(collectionData.count / pageSize));
      setCollection(
        vendorDataAdaptor
          ? vendorDataAdaptor(collectionData, t)
          : collectionData
      );
    }
  }, [collectionData]);

  const [pqType, setPQType] = useState(1);

  function Type(val) {
    getDasheltFilter(val);
    setPQType(val);
  }

  function getDasheltFilter(type) {
    switch (type) {
      case 1:
        setParamsState({
          ...paramsState,
          pageNumber: 1,
          type: 5,
          fromDate: cf,
          toDate: c1t,
        });
        break;
      case 2:
        setParamsState({
          ...paramsState,
          pageNumber: 1,
          type: 5,
          fromDate: c3f,
          toDate: c2t,
        });
        break;
      case 3:
        setParamsState({
          ...paramsState,
          pageNumber: 1,
          type: 16,
          fromDate: null,
          toDate: null,
        });
        break;
      case 4:
        setParamsState({
          ...paramsState,
          pageNumber: 1,
          type: 5,
          fromDate: c5f,
          toDate: c5f,
        });
        break;
      case 5:
        setParamsState({
          ...paramsState,
          pageNumber: 1,
          type: 7,
          fromDate: null,
          toDate: null,
        });
        break;
      default:
        setParamsState({
          ...paramsState,
          pageNumber: 1,
          type: 5,
          fromDate: cf,
          toDate: c1t,
        });
        break;
    }
  }

  function toggleViewType() {
    setViewType(viewType === "list" ? "grid" : "list");
  }

  function setSearchStr(str) {
    setParamsState({ ...paramsState, freeText: str, pageNumber: 1 });
  }

  function setPage(pageNumber) {
    setParamsState((prev) => ({ ...prev, pageNumber }));
  }

  return (
    // <ClientDashboard />
    // <VendorDashboard />
    <CollectionsTemplate
      TitlebarChildren={EmptyComponent}
      page={paramsState.pageNumber}
      setPage={setPage}
      pageCount={pageCount}
      fetchState={{ loading, error }}
      collection={collection}
      viewType={viewType}
      responseDataAdaptor={vendorDataAdaptor}
      ListItemComponent={DashboardListitem}
      GridItemComponent={DashboardGriditem}
      CollectionControls={(props) => (
        <DashboardCollectionControl
          setSearchStr={setSearchStr}
          searchStr={paramsState.freeText}
          toggleViewType={toggleViewType}
          viewType={viewType}
          IsDownload={url}
          searchPlaceholder="Search vendors"
          countInfo={countInfo}
          Type={Type}
          CardType={pqType} //TODO: Active card type
          {...props}
        />
      )}
    />
  );
}
